import {SearchValueObjectsFactory} from '../../search/ValueObjects/factory.js'
import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import UserAlertsErrorsFactory from '../Errors/factory.js'
import {UserAlertsMappersFactory} from '../Mappers/factory.js'
import UserAlertsRepositoriesFactory from '../Repositories/factory.js'
import {UserAlertsServicesFactory} from '../Services/factory.js'
import {UserAlertsListValueObjectFactory} from '../ValueObjects/factory.js'
import CreateAlertUserAlertUseCase from './CreateAlertUserAlertUseCase.js'
import DeleteUserAlertUseCase from './DeleteUserAlertUseCase.js'
import GetUnseenSavedSearchMatchesUseCase from './GetUnseenSavedSearchMatchesUseCase.js'
import GetUserAlertsFilteredProvincesUseCase from './GetUserAlertsFilteredProvincesUseCase.js'
import GetUserAlertsUseCase from './GetUserAlertsUseCase.js'
import ResetUnseenSavedSearchMatchesByIdUseCase from './ResetUnseenSavedSearchMatchesByIdUseCase.js'
import UnsubscribeUserAlertsUseCase from './UnsubscribeUserAlertsUseCase.js'
import UpdateChannelUserAlertUseCase from './UpdateChannelUserAlertUseCase.js'
import UpdateFrequencyUserAlertUseCase from './UpdateFrequencyUserAlertUseCase.js'
import UpdateUserAlertUseCase from './UpdateUserAlertUseCase.js'

class UserAlertsUseCasesFactory {
  static createAlertUserAlertUseCase = ({config}) =>
    new CreateAlertUserAlertUseCase({
      config,
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      getSearchParamsRequestService: UserAlertsServicesFactory.getSearchParamsRequestService({config}),
      repository: UserAlertsRepositoriesFactory.hTTPUserAlertsRepository({
        config
      }),
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      searchHasNoFiltersUserAlertError: UserAlertsErrorsFactory.searchHasNoFiltersUserAlertError
    })

  static getUserAlertsUseCase = ({config}) =>
    new GetUserAlertsUseCase({
      getUserAlertsService: UserAlertsServicesFactory.getUserAlertsService({
        config
      })
    })

  static getUserAlertsFilteredProvincesUseCase = ({config}) =>
    new GetUserAlertsFilteredProvincesUseCase({
      userAlertIdValueObject: UserAlertsListValueObjectFactory.userAlertIdValueObject,
      getUserAlertsFilteredProvincesService: UserAlertsServicesFactory.getUserAlertsFilteredProvincesService({
        config
      })
    })

  static updateChannelUserAlertUseCase = ({config}) =>
    new UpdateChannelUserAlertUseCase({
      repository: UserAlertsRepositoriesFactory.hTTPUserAlertsRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })

  static updateFrequencyUserAlertUseCase = ({config}) =>
    new UpdateFrequencyUserAlertUseCase({
      config,
      repository: UserAlertsRepositoriesFactory.hTTPUserAlertsRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })

  static updateUserAlertUseCase = ({config}) =>
    new UpdateUserAlertUseCase({
      repository: UserAlertsRepositoriesFactory.hTTPUserAlertsRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      fromUserAlertsParamsToRequestValueObjectMapper:
        UserAlertsMappersFactory.fromUserAlertsParamsToRequestValueObjectMapper({config})
    })

  static deleteUserAlertUseCase = ({config}) =>
    new DeleteUserAlertUseCase({
      repository: UserAlertsRepositoriesFactory.hTTPUserAlertsRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })

  static unsubscribeUserAlertsUseCase = ({config}) =>
    new UnsubscribeUserAlertsUseCase({
      repository: UserAlertsRepositoriesFactory.hTTPUserAlertsRepository({
        config
      })
    })

  static getUnseenSavedSearchMatchesUseCase = ({config}) =>
    new GetUnseenSavedSearchMatchesUseCase({
      config,
      getUnseenSavedSearchMatchesService: UserAlertsServicesFactory.getUnseenSavedSearchMatchesService({
        config
      })
    })

  static resetUnseenSavedSearchMatchesByIdUseCase = ({config}) =>
    new ResetUnseenSavedSearchMatchesByIdUseCase({
      config,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      repository:
        typeof localStorage !== 'undefined'
          ? UserAlertsRepositoriesFactory.hTTPUserAlertsRepository({
              config
            })
          : UserAlertsRepositoriesFactory.emptyUserAlertsRepository({
              config
            })
    })
}

export default UserAlertsUseCasesFactory
